export default () => ({
    root: {
        flex: '1 1 100%',
        width: '100%',
    },
});
